import { useState } from 'react';
import { colors } from '../../../../colorVars';
import { Heading4 } from '../../../atomic/text/Text';
import { TopRowExpandButton } from '../../tradeplans/activeTradePlanModule/components/topRows/topRowExpandButton/TopRowExpandButton';
import { TradingModule } from './TradingModule';
import style from './TradingModuleWrapper.module.css';

export const TradingModuleWrapper = () => {
  const [expanded, setExpanded] = useState(true);
  return (
    <div className={style.outerContainer}>
      <div className={style.container}>
        <div className={style.header}>
          <Heading4 color={colors.lightGrey}>Chart Trading</Heading4>
          <TopRowExpandButton
            height="24px"
            width="520px"
            backgroundColor={colors.grey}
            fill={colors.lightGrey}
            clickHandler={() => setExpanded((prev) => !prev)}
            expanded={expanded}
          />
        </div>
      </div>
      {expanded ? <TradingModule /> : null}
    </div>
  );
};
